
// import { useEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';

// const links = ['About','Skills', 'Projects', 'Experience', 'Certificates', 'Blogs', 'Contact'];

// export default function Navbar() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [visible, setVisible] = useState(true);
//   const menuRef = useRef(null);
//   const buttonRef = useRef(null);
//   const lastScrollY = useRef(0);
//   const ticking = useRef(false);

//   // Scroll direction detection
//   useEffect(() => {
//     const handleScroll = () => {
//       if (ticking.current) return;
//       ticking.current = true;

//       requestAnimationFrame(() => {
//         const currentY = window.scrollY;
//         const diff = currentY - lastScrollY.current;

//         if (Math.abs(diff) < 5) {
//           ticking.current = false;
//           return;
//         }

//         if (diff > 0 && currentY > 80) {
//           // Scrolling DOWN
//           setVisible(false);
//         } else {
//           // Scrolling UP
//           setVisible(true);
//         }

//         lastScrollY.current = currentY;
//         ticking.current = false;
//       });
//     };

//     window.addEventListener('scroll', handleScroll, { passive: true });
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // GSAP animate the button in/out
//   useEffect(() => {
//     if (menuOpen) return; // don't hide while menu is open
//     gsap.to(buttonRef.current, {
//       y: visible ? 0 : -70,
//       opacity: visible ? 1 : 0,
//       duration: 0.4,
//       ease: 'power3.inOut',
//     });
//   }, [visible, menuOpen]);

//   useEffect(() => {
//     if (menuOpen) {
//       gsap.fromTo(menuRef.current,
//         { clipPath: 'inset(0 0 100% 0)', opacity: 0 },
//         { clipPath: 'inset(0 0 0% 0)', opacity: 1, duration: 0.6, ease: 'power3.inOut' }
//       );
//       gsap.fromTo('.menu-link',
//         { y: 40, opacity: 0 },
//         { y: 0, opacity: 1, duration: 0.5, stagger: 0.08, delay: 0.2, ease: 'power3.out' }
//       );
//     } else if (menuRef.current) {
//       gsap.to(menuRef.current, { clipPath: 'inset(0 0 100% 0)', opacity: 0, duration: 0.4 });
//     }
//   }, [menuOpen]);

//   const scrollTo = (id) => {
//     if (id === 'Blogs') {
//       setMenuOpen(false);
//       window.open('https://blllogs.netlify.app/', '_blank', 'noopener,noreferrer');
//       return;
//     }
//     setMenuOpen(false);
//     const el = document.getElementById(id.toLowerCase());
//     if (el) el.scrollIntoView({ behavior: 'smooth' });
//   };

//   return (
//     <>
//       {/* Hamburger */}
//       <button
//         ref={buttonRef}
//         data-cursor-text="Menu"
//         onClick={() => setMenuOpen(!menuOpen)}
//         style={{
//           position: 'fixed',
//           top: 20,
//           right: 20,
//           zIndex: 1000,
//           padding: 10,
//           borderRadius: '10px',
//           background: 'var(--white)',
//           border: 'none',
//           cursor: 'pointer',
//           display: 'flex',
//           flexDirection: 'column',
//           gap: 5,
//         }}
//       >
//         <span style={{
//           display: 'block', width: 24, height: 2, background: 'var(--black)',
//           transition: 'transform 0.3s',
//           transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
//         }} />
//         <span style={{
//           display: 'block', width: 24, height: 2, background: 'var(--black)',
//           transition: 'opacity 0.3s',
//           opacity: menuOpen ? 0 : 1,
//         }} />
//         <span style={{
//           display: 'block', width: 24, height: 2, background: 'var(--black)',
//           transition: 'transform 0.3s',
//           transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
//         }} />
//       </button>

//       {/* Full-screen menu */}
//       <div ref={menuRef} style={{
//         position: 'fixed', inset: 0, background: 'var(--black)', zIndex: 999,
//         display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
//         clipPath: 'inset(0 0 100% 0)', opacity: 0,
//         overflowY: 'auto', overflowX: 'hidden',
//         padding: 'clamp(5rem,10vh,7rem) 2rem clamp(3rem,6vh,4rem)',
//         boxSizing: 'border-box',
//       }}>
//         <div style={{
//           display: 'flex', flexDirection: 'column', alignItems: 'center',
//           gap: 'clamp(0.4rem, 2.5vh, 1.8rem)',
//           width: '100%',
//         }}>
//           {links.map((link, i) => (
//             <button
//               key={link}
//               className="menu-link"
//               onClick={() => scrollTo(link)}
//               style={{
//                 fontFamily: 'Syne',
//                 fontSize: 'clamp(1.6rem, 4vw, 4rem)',
//                 fontWeight: 800,
//                 color: 'var(--white)',
//                 letterSpacing: '-0.04em',
//                 opacity: 0,
//                 lineHeight: 1.05,
//                 textTransform: 'uppercase',
//                 transition: 'color 0.2s',
//                 background: 'transparent', border: 'none', cursor: 'pointer',
//                 flexShrink: 0,
//               }}
//               onMouseEnter={e => e.currentTarget.style.color = 'var(--acid)'}
//               onMouseLeave={e => e.currentTarget.style.color = 'var(--white)'}
//             >
//               <span style={{ fontFamily: 'Space Mono', fontSize: '0.32em', color: 'var(--muted)', marginRight: '0.8rem', verticalAlign: 'middle' }}>
//                 0{i + 1}
//               </span>
//               {link}
//             </button>
//           ))}
//         </div>

//         <div style={{ marginTop: 'clamp(1rem, 3vh, 2.5rem)', display: 'flex', gap: '1.5rem', flexShrink: 0 }}>
//           {[
//             { label: 'GitHub',    href: 'https://github.com/Naveenak27' },
//             { label: 'LinkedIn',  href: 'https://www.linkedin.com/in/naveen-karnan-4987811a5' },
//             { label: 'Instagram', href: 'https://instagram.com/_._naveenak_._' },
//           ].map((s, i) => (
//             <a
            
//               key={i}
//               href={s.href}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{
//                 fontFamily: 'Space Mono',
//                 fontSize: '0.6rem',
//                 color: 'var(--muted)',
//                 letterSpacing: '0.12em',
//                 cursor: 'pointer',
//                 transition: 'color 0.2s',
//                 textDecoration: 'none',
//               }}
//               onMouseEnter={e => e.currentTarget.style.color = 'var(--acid)'}
//               onMouseLeave={e => e.currentTarget.style.color = '#333'}
//             >
//               {s.label}
//             </a>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';

const links = ['About','Skills', 'Projects', 'Experience', 'Certificates', 'Blogs', 'Contact'];

// ── Wavy transition helpers ───────────────────────────────────────────────────
// The wrapper is a single SVG path (viewBox 0–100): a band bounded by a
// wavy top edge (a) and a wavy bottom edge (b).
//   cover: bottom edge sweeps down  → screen is fully covered
//   exit : top edge sweeps down     → screen is revealed
const AMP = 10;  // wave height (viewBox units)
const OFF = 15;  // overshoot so the waves fully clear the screen
const N   = 40;  // points per edge

function buildPath(a, b, ph) {
  let d = '';
  for (let i = 0; i <= N; i++) {
    const x = (i / N) * 100;
    const y = a + Math.sin((x / 100) * Math.PI * 2 + ph) * AMP;
    d += `${i ? 'L' : 'M'}${x},${y} `;
  }
  for (let i = N; i >= 0; i--) {
    const x = (i / N) * 100;
    const y = b + Math.sin((x / 100) * Math.PI * 2 + ph) * AMP;
    d += `L${x},${y} `;
  }
  return d + 'Z';
}

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  // Transition refs
  const overlayRef = useRef(null);
  const pathRef = useRef(null);
  const waveState = useRef({ a: -OFF, b: -OFF, ph: 0 });
  const transitioning = useRef(false);
  const tlRef = useRef(null);

  // Scroll direction detection
  useEffect(() => {
    const handleScroll = () => {
      if (ticking.current) return;
      ticking.current = true;

      requestAnimationFrame(() => {
        const currentY = window.scrollY;
        const diff = currentY - lastScrollY.current;

        if (Math.abs(diff) < 5) {
          ticking.current = false;
          return;
        }

        if (diff > 0 && currentY > 80) {
          // Scrolling DOWN
          setVisible(false);
        } else {
          // Scrolling UP
          setVisible(true);
        }

        lastScrollY.current = currentY;
        ticking.current = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // GSAP animate the button in/out
  useEffect(() => {
    if (menuOpen) return; // don't hide while menu is open
    gsap.to(buttonRef.current, {
      y: visible ? 0 : -70,
      opacity: visible ? 1 : 0,
      duration: 0.4,
      ease: 'power3.inOut',
    });
  }, [visible, menuOpen]);

  useEffect(() => {
    if (menuOpen) {
      gsap.fromTo(menuRef.current,
        { clipPath: 'inset(0 0 100% 0)', opacity: 0 },
        { clipPath: 'inset(0 0 0% 0)', opacity: 1, duration: 0.6, ease: 'power3.inOut' }
      );
      gsap.fromTo('.menu-link',
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5, stagger: 0.08, delay: 0.2, ease: 'power3.out' }
      );
    } else if (menuRef.current) {
      gsap.to(menuRef.current, { clipPath: 'inset(0 0 100% 0)', opacity: 0, duration: 0.4 });
    }
  }, [menuOpen]);

  // Kill any running transition on unmount
  useEffect(() => () => tlRef.current?.kill(), []);

  const drawWave = () => {
    const w = waveState.current;
    pathRef.current?.setAttribute('d', buildPath(w.a, w.b, w.ph));
  };

  const resetWave = () => {
    Object.assign(waveState.current, { a: -OFF, b: -OFF, ph: 0 });
    pathRef.current?.setAttribute('d', '');
  };

  const scrollTo = (id) => {
    if (id === 'Blogs') {
      setMenuOpen(false);
      window.open('https://blllogs.netlify.app/', '_blank', 'noopener,noreferrer');
      return;
    }

    if (transitioning.current) return;
    transitioning.current = true;

    const wave = waveState.current;
    const END = 100 + OFF;
    const ease = 'power3.inOut';

    overlayRef.current.style.pointerEvents = 'auto'; // block clicks while animating

    const tl = gsap.timeline({
      onUpdate: drawWave,
      onComplete: () => {
        resetWave();
        overlayRef.current.style.pointerEvents = 'none';
        transitioning.current = false;
      },
    });
    tlRef.current = tl;

    // 1) COVER – wrapper sweeps down over the screen
    tl.fromTo(wave, { b: -OFF, ph: 0 }, { b: END, ph: Math.PI, duration: 0.8, ease }, 0);

    // 2) Screen is fully covered → close menu + jump to the section instantly
    tl.call(() => {
      setMenuOpen(false);
      const el = document.getElementById(id.toLowerCase());
      if (el) el.scrollIntoView({ behavior: 'instant', block: 'start' });
      lastScrollY.current = window.scrollY;
      setVisible(true);
    });

    // 3) EXIT – wrapper sweeps out the bottom, revealing the section
    tl.addLabel('exit', '+=0.15');
    tl.to(wave, { a: END, ph: Math.PI * 2, duration: 0.8, ease }, 'exit');
  };

  return (
    <>
      {/* Page-transition wrapper */}
      <div
        ref={overlayRef}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 2000,
          pointerEvents: 'none',
        }}
      >
        <svg
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          style={{ width: '100%', height: '100%', display: 'block' }}
        >
          <path ref={pathRef} style={{ fill: 'var(--acid)' }} />
        </svg>
      </div>

      {/* Hamburger */}
      <button
        ref={buttonRef}
        data-cursor-text="Menu"
        onClick={() => setMenuOpen(!menuOpen)}
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 1000,
          padding: 10,
          borderRadius: '10px',
          background: 'var(--white)',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          gap: 5,
        }}
      >
        <span style={{
          display: 'block', width: 24, height: 2, background: 'var(--black)',
          transition: 'transform 0.3s',
          transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
        }} />
        <span style={{
          display: 'block', width: 24, height: 2, background: 'var(--black)',
          transition: 'opacity 0.3s',
          opacity: menuOpen ? 0 : 1,
        }} />
        <span style={{
          display: 'block', width: 24, height: 2, background: 'var(--black)',
          transition: 'transform 0.3s',
          transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
        }} />
      </button>

      {/* Full-screen menu */}
      <div ref={menuRef} style={{
        position: 'fixed', inset: 0, background: 'var(--black)', zIndex: 999,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        clipPath: 'inset(0 0 100% 0)', opacity: 0,
        overflowY: 'auto', overflowX: 'hidden',
        padding: 'clamp(5rem,10vh,7rem) 2rem clamp(3rem,6vh,4rem)',
        boxSizing: 'border-box',
      }}>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          gap: 'clamp(0.4rem, 2.5vh, 1.8rem)',
          width: '100%',
        }}>
          {links.map((link, i) => (
            <button
              key={link}
              className="menu-link"
              onClick={() => scrollTo(link)}
              style={{
                fontFamily: 'Syne',
                fontSize: 'clamp(1.6rem, 4vw, 4rem)',
                fontWeight: 800,
                color: 'var(--white)',
                letterSpacing: '-0.04em',
                opacity: 0,
                lineHeight: 1.05,
                textTransform: 'uppercase',
                transition: 'color 0.2s',
                background: 'transparent', border: 'none', cursor: 'pointer',
                flexShrink: 0,
              }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--acid)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--white)'}
            >
              <span style={{ fontFamily: 'Space Mono', fontSize: '0.32em', color: 'var(--muted)', marginRight: '0.8rem', verticalAlign: 'middle' }}>
                0{i + 1}
              </span>
              {link}
            </button>
          ))}
        </div>

        <div style={{ marginTop: 'clamp(1rem, 3vh, 2.5rem)', display: 'flex', gap: '1.5rem', flexShrink: 0 }}>
          {[
            { label: 'GitHub',    href: 'https://github.com/Naveenak27' },
            { label: 'LinkedIn',  href: 'https://www.linkedin.com/in/naveen-karnan-4987811a5' },
            { label: 'Instagram', href: 'https://instagram.com/_._naveenak_._' },
          ].map((s, i) => (
            <a

              key={i}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontFamily: 'Space Mono',
                fontSize: '0.6rem',
                color: 'var(--muted)',
                letterSpacing: '0.12em',
                cursor: 'pointer',
                transition: 'color 0.2s',
                textDecoration: 'none',
              }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--acid)'}
              onMouseLeave={e => e.currentTarget.style.color = '#333'}
            >
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </>
  );
}